import React, { useMemo, useState, useEffect } from 'react';
import useReactApexChart from '../../hook/useReactApexChart';
import ReactApexChart from 'react-apexcharts';

const MakePieChart = ({ makeUsage = [], value, onChange }) => {
  let { userOverviewDonutChartOptions } = useReactApexChart();

  // 🔹 Build series & labels dynamically
  const { series, labels } = useMemo(() => {
    return {
      series: makeUsage.map(item => item.makeCount || 0),
      labels: makeUsage.map(item => item.make)
    };
  }, [makeUsage]);

  // const colors = useMemo(() => {
  //     return makeUsage.map((_, index) =>
  //         `hsl(${(index * 360) / makeUsage.length}, 70%, 55%)`
  //     );
  // }, [makeUsage]);


  // 🔹 Inject dynamic labels into options (no CSS change)


  // ✅ Check if there is valid data
  const hasData = useMemo(() => {
    return makeUsage.length > 0 && series.some(val => val > 0);
  }, [makeUsage, series]);

  const chartKey = useMemo(() => {
    return makeUsage
      .map(m => `${m.make}:${m.makeCount}`)
      .join("|");
  }, [makeUsage]);

  // 🔹 Track window width
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 🔹 Set responsive height and donut size
  const chartHeight = windowWidth <= 768 ? 220 : 340;
  const donutSize = windowWidth <= 1400 ? '50%' : '60%';

  const chartOptions = {
    ...userOverviewDonutChartOptions,
    labels,
    plotOptions: {
      pie: { donut: { size: donutSize } },
    },
    chart: {
      ...userOverviewDonutChartOptions.chart,
      offsetY: 10,
    },
    grid: { padding: { top: 0, bottom: 0, left: 0, right: 0 } },
  };


  return (
    <div className="w-100">
      <div className="card h-100 radius-8 border-0">
        <div className="card-body p-24 d-flex flex-column justify-content-between gap-8">
          <h6 className="fw-bold text-lg mb-0">Vehicle Makes</h6>

          <div
            className="d-flex justify-content-center align-items-center "
            style={{ height: chartHeight }}
          >
            {hasData ? (
              <ReactApexChart
                key={chartKey}
                options={chartOptions}
                series={series}
                type="donut"
                height={chartHeight} // dynamic height
              />
            ) : (
              <div
                className="text-center d-flex align-items-center justify-content-center"
                style={{ color: "#c0c0c0" }}
              >
                No data found
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MakePieChart;
